var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#003032"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6488 8.3359C18.1804 7.88807 17.4209 7.888 16.9525 8.3359L11.3519 13.6923C11.1754 13.8611 11.0653 14.0691 11.0218 14.2871C10.9487 14.6485 11.0592 15.0374 11.3519 15.3173L16.9525 20.6738C17.4208 21.1215 18.1804 21.1213 18.6488 20.6738C19.1172 20.2259 19.1172 19.4987 18.6488 19.0507L13.8949 14.5039L18.6488 9.95797C19.1172 9.51003 19.1172 8.78383 18.6488 8.3359Z",
    fill: "#003032"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/back_button.e18ac78894415f7dbe35ef1e78dddd6f.svg";
export { ForwardRef as ReactComponent };